<template>
  <div class="whatscovered-nav hammodal">
    <span
      id="whatscoveredabutton"
      :class="{ active: pageNumber == 1 }"
      @click="pageNumber = 1"
    >
      Property Damage &amp; Personal Liability
    </span>
    <span
      id="whatscoveredabutton"
      :class="{ active: pageNumber == 2 }"
      @click="pageNumber = 2"
    >
      Personal Property Coverage
    </span>
  </div>
  <!-------------------------------------------->
  <div
    class="whatscoveredwindow"
    :style="[pageNumber == 1 ? { display: 'block' } : { display: 'none' }]"
  >
    <h4>Property Damage Liability</h4>
    <div class="poweredby-hotspot">
      <span class="poweredby">Provided by Assurant</span>
      <p class="poweredby-content">
        In all states, unless otherwise noted, Renters Insurance is underwritten
        by American Bankers Insurance Company of Florida with its home office in
        Miami, Florida. In Minnesota, the underwriter is American Security
        Insurance company. In Georgia, Residents Liability is underwritten by
        Voyager Indemnity Insurance Company. In Utah, coverage is provided under
        policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is
        used to associate their products and services, and to connect with the
        brand of their parent company, Assurant, Inc.
      </p>
    </div>
    <p>
      Property Damage Liability insurance covers damages to your college dorm,
      landlord's apartment, or your neighbor's property when you are at fault.
    </p>

    <p>
      Property covered under this policy would be items the rental unit came
      with (e.g. stove, fridge, sink, toilet) or the building itself.
    </p>

    <p>
      If you are liable for damages, renters insurance can help save you the
      stress of having to pay out-of-pocket. When a covered incident happens,
      all you have to take care of is a small deductible – we’ll cover the Rest
      Rest easy and have peace of mind.
    </p>

    <br />
    <hr />
    <br />

    <h5>Incidents Covered</h5>

    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img :src="require('@/assets/images/icon1.svg')" alt="Fire" />
          </td>

          <td valign="top">
            <strong>Fire</strong><br />Like a grease fire resulting in damage to
            to the kitchen counters and appliances.
          </td>
        </tr>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon10.svg')"
              alt="Water Flood"
            />
          </td>

          <td valign="top">
            <strong>Water *</strong><br />Left the sink on? We’ll cover damage
            to the floor &amp; the neighbor’s items on the floor below you.
            <br />
            <small
              >*In North Carolina, water damage liability is optional for
              renters insurance.</small
            >
          </td>
        </tr>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon11.svg')"
              alt="Smoke Damage"
            />
          </td>

          <td valign="top">
            <strong>Smoke</strong><br />Leaving candles unattended may result in
            in smoke damage.
          </td>
        </tr>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img :src="require('@/assets/images/icon12.svg')" alt="Explosion" />
          </td>

          <td valign="top">
            <strong>Explosion</strong><br />Science experiment gone wrong? We’ll
            We’ll cover the damage!
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <hr />
    <br />

    <h5>Includes Personal Liability</h5>

    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon2.svg')"
              alt="Personal Injury Renters Insurance"
            />
          </td>

          <td>
            If a guest gets injured, the insurer will cover the necessary
            medical and legal expenses.
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <hr />
    <br />

    <p>
      <small style="line-height: 22px">
        See your proof of insurance booklet (provided after purchase) to view
        complete coverage details including limitations and exclusions (terms
        and conditions). Coverages vary by state.
        <router-link :to="{ name: 'legalAssurant' }"
          >Assurant underwriter</router-link
        >
      </small>
    </p>
  </div>
  <!----------------------------------------------------------------------------------------------->
  <div
    class="whatscoveredwindow"
    :style="[pageNumber == 2 ? { display: 'block' } : { display: 'none' }]"
  >
    <h4>Personal Property Coverage</h4>
    <div class="poweredby-hotspot">
      <span class="poweredby">Provided by Assurant</span>
      <p class="poweredby-content">
        In all states, unless otherwise noted, Renters Insurance is underwritten
        by American Bankers Insurance Company of Florida with its home office in
        Miami, Florida. In Minnesota, the underwriter is American Security
        Insurance company. In Georgia, Residents Liability is underwritten by
        Voyager Indemnity Insurance Company. In Utah, coverage is provided under
        policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is
        used to associate their products and services, and to connect with the
        brand of their parent company, Assurant, Inc.
      </p>
    </div>
    <p>
      Personal Property Coverage will cover your TV, furniture, small
      appliances, bike, guitar, classroom materials, and more! Think about how
      much it would cost to replace all your belongings if there was a fire,
      water damage, or burglary in your dorm. You will be reimbursed for what it
      it costs to repair or replace your things.
    </p>
    <br />
    <hr />
    <br />
    <h5>Incidents Covered</h5>
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img :src="require('@/assets/images/icon15.svg')" alt="Fire" />
          </td>

          <td valign="top">
            <strong>Theft &amp; Vandalism</strong><br />
            Was your gaming system stolen? We’ll make sure you have a
            replacement in no time!
          </td>
        </tr>

        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img :src="require('@/assets/images/icon1.svg')" alt="Fire" />
          </td>

          <td valign="top">
            <strong>Fire, Water Damage &amp; Other Covered Perils</strong>
            <br />
            Did your apartment get flooded? Get reimbursed for items that got
            destroyed.
          </td>
        </tr>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img :src="require('@/assets/images/icon14.svg')" alt="Fire" />
          </td>

          <td valign="top">
            <strong>Power Surge By Lightning</strong><br />
            Computer not working after a storm? We will help you get it
            repaired!
          </td>
        </tr>
      </tbody>
    </table>
    <div style="padding: 20px 0px; color: #777; letter-styling: italics">
      <small
        >Also Covered: Smoke, Explosion, Windstorm, Hail, Ice, Snow, Sleet, Pipe
        Pipe Bursts, Cracked AC, Water/Heating System, Freezing, Volcanic
        Eruption
      </small>
    </div>
    <br />
    <hr />
    <br />
    <h5>Items covered</h5>
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="whatscovered-bullets"
    >
      <tbody>
        <tr>
          <td valign="top" width="15%" class="whatscovered-icon">
            <img
              :src="require('@/assets/images/icon13.svg')"
              alt="Items Covered"
            />
          </td>
          <td>
            Laptops, Tablets, Cell Phones, TVs, Blu-ray Players, Game Consoles,
            Consoles, Cameras, Clothing, Jewelry, Sports Equipment, Musical
            Instruments, Books, Furniture, Appliances and more.
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <hr />
    <br />
    <p>
      <small style="line-height: 22px">
        See your proof of insurance booklet (provided after purchase) to view
        complete coverage details including limitations and exclusions (terms
        and conditions). Coverages vary by state.
        <router-link :to="{ name: 'legalAssurant' }"
          >Assurant underwriter</router-link
        >
      </small>
    </p>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

const pageNumber = ref(1);
// This function is not used
// const assurantBookletPath: ComputedRef<string> = computed(() => {
//   return window.location.href + "assets/assurantpolicybooklet.pdf";
// });
</script>
